import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritGameAssets} from "../../TrueGritGameAssets";
import {TrueGritParticleConfig} from "../../configs/TrueGritParticleConfig";
import {Emitter} from "pixi-particles";
import {ParticlesManager} from "../../../core/ParticlesManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TrueGritStatics} from "../../TrueGritStatics";

export class SnowParticlesView extends PIXI.Container implements StageLayer {

    private _snowEmitter:Emitter;

    constructor() {
        super();
        this.name = "rainSnowParticles";
        this.initAnimations();
    }

    private initAnimations():void {
        const snowParticleTextures:PIXI.Texture[] = [
            TrueGrit.assetLoader.getTextures(TrueGritGameAssets.SNOW_PARTICLE_1)[0],
            TrueGrit.assetLoader.getTextures(TrueGritGameAssets.SNOW_PARTICLE_2)[0],
            TrueGrit.assetLoader.getTextures(TrueGritGameAssets.SNOW_PARTICLE_3)[0]
        ];

        this._snowEmitter = new Emitter(this, snowParticleTextures, TrueGritParticleConfig.backgroundConfig0);
        ParticlesManager.addEmitter(this._snowEmitter, true);

        this.onResize();
    }

    onResize():void {
        this.position.y = 0;
        if(!NolimitApplication.isLandscape) {
            this.position.y = this.position.y - (TrueGritStatics.PORTRAIT_Y_OFFSET + NolimitApplication.screenBounds.top) / 2;
        }
        const screenRect:PIXI.Rectangle = new PIXI.Rectangle(
            (NolimitApplication.screenBounds.left - 300),
            (NolimitApplication.screenBounds.top - 700),
            NolimitApplication.screenBounds.width,
            (NolimitApplication.screenBounds.height + 400));
        this._snowEmitter.spawnRect = screenRect;
    }

    public startSnow():void {
        this._snowEmitter.emit = true;
    }

    public stopSnow():void {
        this._snowEmitter.emit = false;
    }
}